/**
 * Layout: featured — the standard card with emphasis.
 *
 * Structurally identical to standard; the difference is presentational (accent
 * border, lift, accent-filled badge) and lives in CSS keyed on
 * `.rfhq-pc--featured`. Written as its own file rather than a flag on standard
 * so that emphasis can diverge later without standard growing a branch.
 */

import { render as renderStandard } from './standard.js';
import { cardRoot } from './root.js';

export function render(model, ctx) {
	// Reuse standard's composition, then restamp the root so the CSS hook and
	// the layout name agree. cardRoot is the single place that name is applied.
	const card = renderStandard(model, ctx);
	card.setAttribute(
		'class',
		card.getAttribute('class').replace('rfhq-pc--standard', 'rfhq-pc--featured')
	);
	const inner = card.querySelector('.card');
	if (inner) {
		inner.setAttribute(
			'class',
			inner.getAttribute('class').replace('rfhq-pc-card--standard', 'rfhq-pc-card--featured')
		);
	}
	return card;
}
